import React, {
  useCallback,
  useMemo,
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

// styles used by the others components.
import {
  QuestionLabel,
  TextError,
  Container,
} from '../styles';

// styles local.
import {
  Difficulty,
  Checkbox,
  RangeRadioContainer,
  Ranges,
  Label,
} from './styles';

const RangeQuestionType = (props) => {
  const {
    questionOptions,
    label,
    leftLabel,
    rightLabel,
    errorText,
    errorField,
    selectedValue,
    onChange,
  } = props;

  const onRangeRadioContainerClicked = useCallback((value) => {
    onChange(value);
  }, [onChange]);
  const questionOptionsSorted = useMemo(() => _.sortBy(questionOptions, (option) => parseInt(option.label, 10)), [questionOptions]);

  return (
    <Container>
      <QuestionLabel>{label}</QuestionLabel>

      <Ranges>
        {_.map(questionOptionsSorted, (option) => (
          <RangeRadioContainer>
            <label>
              <Checkbox
                radio
                key={option.id}
                label={option.label}
                value={option.id}
                onChange={() => onRangeRadioContainerClicked(option.id)}
                checked={selectedValue === option.id}
              />
            </label>
          </RangeRadioContainer>
        ))}
      </Ranges>

      <Difficulty>
        <Label>{leftLabel}</Label>
        <Label>{rightLabel}</Label>
      </Difficulty>

      {errorField && (
        <TextError>
          {errorText}
        </TextError>
      )}

    </Container>
  );
};

RangeQuestionType.propTypes = {
  label: PropTypes.string.isRequired,
  errorText: PropTypes.string,
  questionOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    id: PropTypes.string,
  })).isRequired,
  rightLabel: PropTypes.string.isRequired,
  leftLabel: PropTypes.string.isRequired,
  errorField: PropTypes.bool,
  selectedValue: PropTypes.string,
  onChange: PropTypes.func,
};

RangeQuestionType.defaultProps = {
  errorText: 'Please select an answer',
  errorField: false,
  selectedValue: '',
  onChange: () => { },
};

export default RangeQuestionType;
